var map = {
	"./BB1.png": 3720,
	"./BB2.png": 2960,
	"./BB3.png": 5354,
	"./BI.png": 6182,
	"./C.png": 7790,
	"./G.png": 8842,
	"./K1.png": 5181,
	"./K2.png": 1414,
	"./K3.png": 6511,
	"./K4.png": 640,
	"./K5.png": 6393,
	"./K6.png": 2386,
	"./Kj4.png": 648,
	"./Kj5.png": 1777,
	"./Kj6.png": 1194,
	"./MR.png": 560,
	"./PR.png": 2307,
	"./V.png": 9683
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1352;